import React, { useState, useEffect } from "react";
import { useAuth } from "../Management/AuthContext";
import axios from "axios";
import { Divider, TextField } from "@mui/material";
import { Button } from "flowbite-react";
import { Datepicker } from "flowbite-react";
import TextEditor from "../tiptap-editor";

import ButtonDel from "../Button/ButtonDel";
import ButtonEdit from "../Button/ButtonEdit";
import ToggleSwitch from "./ToggleSwitch";

const slugify = require("slugify");

const defaultNewsItem = {
  id: 0,
  title: "",
  slug: "",
  metaTag: "",
  shortContent: "",
  mainContent: "",
  categories: [],
  tags: "",
  featured: false,
  author: "",
  publishDate: new Date(),
  enableComment: false,
  status: 1,
};

export default function NewManagementDetail({
  categories,
  newData,
  onSaveData,
}) {
  const { user } = useAuth();
  const [listCategory, setListCategory] = useState(categories);
  const [editItem, setEditItem] = useState({
    ...defaultNewsItem,
    author: user.displayName,
  });
  const [headerTitle, setHeaderTitle] = useState("TẠO BÀI VIẾT MỚI");

  useEffect(() => {
    if (categories) {
      setListCategory(categories);
    }
  }, [categories]);

  const handleSelectCategory = (e) => {
    const value = e.target.value;
    if (e.target.checked) {
      setEditItem((pre) => ({
        ...pre,
        categories: [...pre.categories, Number(value)],
      }));
    } else {
      setEditItem((pre) => ({
        ...pre,
        categories: pre.categories.filter((item) => item != value),
      }));
    }
  };

  const handleSaveNews = async () => {
    // console.log(editItem)
    if (!editItem.title || !editItem.title.trim()) {
      alert("Hãy nhập tiêu đề bài viết");
      return;
    }
    if (!editItem.slug || !editItem.slug.trim()) {
      alert("Hãy nhập tiêu đề bài viết");
      return;
    }
    if (!editItem.shortContent || !editItem.shortContent.trim()) {
      alert("Hãy nhập nội dung tóm tắt bài viết");
      return;
    }
    if (!editItem.mainContent || !editItem.mainContent.trim()) {
      alert("Hãy nhập nội dung bài viết");
      return;
    }
    axios.defaults.headers.common["Authorization"] = `Bearer ${user.token}`;
    const response = await axios.post(
      "https://api-bluerise.bluerise.com.vn/news/save",
      {
        ...editItem,
        type: 1,
        categories: editItem.categories.toString(),
        publishDate: new Date(new Date(editItem.publishDate).setHours(0, 0, 0)),
      }
    );
    if (response.status == 200) {
      if (response.data == 0) {
        alert("Trùng Slug (kiểm tra tiêu đề bài viết đã tồn tại)");
      } else {
        alert("Lưu bài viết thành công");
        onSaveData();
      }
    }
  };
  useEffect(() => {
    if (newData && newData.id) {
      setEditItem({
        ...newData,
        categories: newData.categories
          ? newData.categories
              .split(",")
              .map((num) => Number(num))
              .filter((n) => n > 0)
          : [],
      });
      setHeaderTitle("CẬP NHẬT BÀI VIẾT");
    } else {
      setEditItem({ ...defaultNewsItem, author: user.displayName });
      setHeaderTitle("TẠO BÀI VIẾT MỚI");
    }
  }, [newData]);
  return (
    <div className="w-full bg-white border border-gray-200 flex items-center justify-center h-auto flex-col gap-6 px-[20px] py-[30px]">
      <div>{headerTitle}</div>
      <div className="w-full">
        <Divider />
      </div>
      <div className="w-full flex flex-col gap-3 border border-gray-300 px-[10px] py-[20px] rounded-lg">
        <div className="font-semibold text-center">THÔNG TIN CƠ BẢN</div>
        <div>
          <ToggleSwitch
            checked={editItem.showRegisterForm}
            onChange={(v) => {
              setEditItem((pre) => ({
                ...pre,
                showRegisterForm: v,
              }));
            }}
          />
        </div>

        <div className="w-full">
          <input
            type="text"
            className="w-full rounded-lg"
            placeholder="Tiêu đề bài viết"
            value={editItem.title}
            onChange={(e) =>
              setEditItem((pre) => ({
                ...pre,
                title: e.target.value,
                slug: slugify(e.target.value, {
                  lower: true,
                  remove: /[*+~.()'"!:@,¿?]/g,
                }),
              }))
            }
          />
        </div>

        <div className="w-full">
          <input
            type="url"
            className="w-full rounded-lg"
            placeholder="Đường dẫn URL"
            value={editItem.slug}
            onChange={(e) =>
              setEditItem((pre) => ({
                ...pre,
                slug: e.target.value,
              }))
            }
          />
        </div>

        <div className="full">
          <input
            type="text"
            className="w-full rounded-lg"
            placeholder="Nhập mô tả (Meta Description)"
            value={editItem.metaTag}
            onChange={(e) =>
              setEditItem((pre) => ({
                ...pre,
                metaTag: e.target.value,
              }))
            }
          />
        </div>
      </div>
      <div className="w-full flex flex-col gap-3 border border-gray-300 px-[10px] py-[20px] rounded-lg">
        <div className="font-semibold text-center">NỘI DUNG TÓM TẮT</div>
        <TextEditor
          data={editItem.shortContent}
          setData={(value) =>
            setEditItem((pre) => ({
              ...pre,
              shortContent: value,
            }))
          }
          editable
          isBold={false}
        />
      </div>

      <div className="w-full flex flex-col gap-3 border border-gray-300 px-[10px] py-[20px] rounded-lg ">
        <div className="font-semibold text-center">NỘI DUNG CHÍNH</div>
        <div className="sticky h-[500px] top-0 overflow-scroll overflow-x-hidden ">
          <TextEditor
            className="sticky h-[500px] top-0 overflow-scroll"
            data={editItem.mainContent}
            setData={(value) =>
              setEditItem((pre) => ({
                ...pre,
                mainContent: value,
              }))
            }
            editable
            isBold={false}
          />
        </div>
      </div>

      <div className="w-full flex flex-col gap-5 border border-gray-300 px-[10px] py-[20px] rounded-lg">
        <div className="w-full ">
          <div className="font-semibold text-center">DANH MỤC VÀ THẺ</div>
          <div className="w-full flex items-center justify-end gap-4">
            {/* <ButtonAdd /> */}

            <ButtonEdit
              id={0}
              name={""}
              onSaved={(updatedObj) => {
                setListCategory([
                  ...listCategory,
                  { id: updatedObj.id, name: updatedObj.categoryName },
                ]);
              }}
            />
            {editItem.categories.length > 0 && (
              <ButtonEdit
                id={editItem.categories.length > 0 ? editItem.categories[0] : 0}
                name={
                  categories.find(
                    (c) =>
                      c.id ==
                      (editItem.categories.length > 0
                        ? editItem.categories[0]
                        : 0)
                  )?.name
                }
                onSaved={(updatedObj) => {
                  const updatedList = listCategory.map((category) => {
                    if (category.id === updatedObj.id) {
                      return { ...category, name: updatedObj.categoryName };
                    } else {
                      return category;
                    }
                  });
                  setListCategory(updatedList);
                }}
              />
            )}
            {editItem.categories.length > 0 && (
              <ButtonDel
                id={editItem.categories.length > 0 ? editItem.categories[0] : 0}
                onDeleted={(deletedId) => {
                  setListCategory(
                    listCategory.filter((c) => c.id != deletedId)
                  );
                  setEditItem((pre) => ({
                    ...pre,
                    categories: [],
                  }));
                }}
              />
            )}
          </div>
        </div>

        <div className="w-full border border-gray-300 rounded-lg px-[20px] py-[20px]">
          {listCategory &&
            listCategory.map((cat) => (
              <div key={cat.id} className="flex items-center">
                <input
                  type="checkbox"
                  value={cat.id}
                  checked={
                    editItem.categories && editItem.categories.includes(cat.id)
                  }
                  onChange={handleSelectCategory}
                  className="form-checkbox h-5 w-5 text-blue-600"
                />
                <span className="ml-2">{cat.name}</span>
              </div>
            ))}
        </div>
        <div className="w-full">
          <input
            type="text"
            className="w-full rounded-lg"
            placeholder='Thẻ tags (các thẻ cách nhau dấu phảy ",")'
            value={editItem.tags}
            onChange={(e) =>
              setEditItem((pre) => ({
                ...pre,
                tags: e.target.value,
              }))
            }
          />
        </div>
      </div>
      <div className="w-full flex flex-col gap-5 border border-gray-300 px-[10px] py-[20px] rounded-lg">
        <div className="font-semibold text-center">CÀI ĐẶT NÂNG CAO</div>
        <div className="w-full border border-gray-300 rounded-lg">
          {" "}
          <select
            name="position"
            className="flex-1 bg-transparent outline-none border-none placeholder-gray-500 w-full"
            value={editItem.status}
            onChange={(e) =>
              setEditItem((pre) => ({
                ...pre,
                status: Number(e.target.value),
              }))
            }
          >
            {" "}
            <option value="">Trạng thái bài viết</option>{" "}
            <option value="0">Nháp</option> <option value="1">Chờ duyệt</option>{" "}
            <option value="2">Xuất bản</option>{" "}
          </select>{" "}
        </div>{" "}
        <div className="flex flex-col gap-2">
          {" "}
          <label>Ngày giờ xuất bản</label>
          <Datepicker
            language="vi-VN"
            labelTodayButton="Hôm nay"
            labelClearButton="Xóa"
            value={editItem.publishDate}
            onChange={(value) =>
              setEditItem((pre) => ({
                ...pre,
                publishDate: value,
              }))
            }
          />{" "}
        </div>
        <label>Tác giả bài viết</label>
        <div className="w-full border border-gray-300 rounded-lg">
          <input
            type="text"
            className="w-full rounded-lg"
            placeholder="Tự động import tác giả theo bài viết"
            value={editItem.author}
            onChange={(e) =>
              setEditItem((pre) => ({
                ...pre,
                author: e.target.value,
              }))
            }
          />
        </div>
        <div className="flex flex-col space-y-2">
          <div className="flex items-center">
            <input
              type="checkbox"
              value="chkFeatured"
              checked={editItem.featured}
              onChange={(e) =>
                setEditItem((pre) => ({
                  ...pre,
                  featured: e.target.checked,
                }))
              }
              className="form-checkbox h-5 w-5 text-blue-600"
            />
            <span className="ml-2">Bài viết nổi bật?</span>
          </div>
        </div>
        <div className="flex flex-col space-y-2">
          <div className="flex items-center">
            <input
              type="checkbox"
              value="chkComment"
              checked={editItem.enableComment}
              onChange={(e) =>
                setEditItem((pre) => ({
                  ...pre,
                  enableComment: e.target.checked,
                }))
              }
              className="form-checkbox h-5 w-5 text-blue-600"
            />
            <span className="ml-2">Cho phép bình luận?</span>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center">
        <Button
          className="bg-green-400 hover:bg-green-500 w-40 font-semibold"
          onClick={handleSaveNews}
        >
          Lưu
        </Button>
      </div>
    </div>
  );
}
